export default (() => {

    const calculateNetTotal = (booking) => {

        return booking.total_charge - booking.vat;
    };

    return {
        calculateNetTotal
    };

})();


// WEBPACK FOOTER //
// ./services/bookingCalculator.js